<template>
  <div class="flex flex-col justify-center items-center">
    <h1 class="font-bold text-jblue-secondary text-2xl text-center md:text-left">{{ $t('messages.tell_friends.share.title')}}</h1>
    <div class="w-4/5 text-justify">{{ $t('messages.tell_friends.share.intro')}}</div>
    <br>
    <h1 class="font-bold text-jblue-secondary text-2xl text-center md:text-left">{{ $t('messages.tell_friends.share.title2')}}</h1>
    <div class="w-4/5 text-center">{{ $t('messages.tell_friends.share.intro2')}}</div>

    <div class="flex justify-center flex-col items-center sm:items-baseline sm:flex-row mb-4 mt-4">
      <a class="w-64 md:w-40" target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=www.jwperfectmatch.com">
        <div class="flex items-center mb-4 sm:mb-0 text-white share-button btn-facebook py-2 px-3 font-bold">
          <img class="mr-4 h-8" src="/storage/image/share/share-fb.svg" alt />
          {{ $t('messages.tell_friends.share.facebook')}}
        </div>
      </a>
      <a class="w-64 md:w-48" target="_blank" :href="`http://twitter.com/share?text=${this.$t('messages.tell_friends.share.twitter_message')}&url=https://www.jwperfectmatch.com/`">
        <div class="flex items-center mb-4 sm:mb-0 ml-1 md:ml-8 text-white share-button btn-twitter py-2 px-3 font-bold">
          <img class="mr-4 h-8" src="/storage/image/share/share-twitter.svg" alt />
          {{ $t('messages.tell_friends.share.twitter')}}
        </div>
      </a>
      <router-link
        v-if="!email"
        :to="{
          name: 'share',
          params: {
            lang: locale
          }
        }"
        class="w-64 md:w-48">
        <div class="flex items-center ml-1 md:ml-8 text-white share-button btn-facebook py-2 px-3 font-bold">
          <img class="mr-4 h-8" src="/storage/image/share/share-email.svg" alt />
          {{ $t('messages.tell_friends.share.email')}}
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "ShareWithFriendButton",
  props: {
    email: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState("locale", ["locale"])
  },
};
</script>
<style lang="scss">
.btn-tell-friends {
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.3);
  border-radius: 100px 16px 16px 100px;
}
.share-button {
  border-radius: 16px;

  &.btn-facebook {
    background: linear-gradient(81.84deg, #1C4C91 0%, #3A91F9 98.24%);
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.3);
  }

  &.btn-twitter {
    background: linear-gradient(82.24deg, #2FB4FF 0%, #2D9AFF 98.24%);
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.3);
  }
}
</style>
